export default function updateLocalRenterProfile({ state }, { userId, updates }) {
  const fieldIds = Object.keys(updates);

  for (const fieldId of fieldIds) {
    state.set(['household', 'renterProfilesByUserId', userId, fieldId], updates[fieldId]);
  }

  state.commit();

  return state.get(['household', 'renterProfilesByUserId', userId]);
}
